import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Button,
  CircularProgress,
  Container,
  Breadcrumbs,
  Fade,
  Divider,
  ListItemIcon,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

// アイコン
import SettingsIcon from "@mui/icons-material/Settings";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import LockIcon from "@mui/icons-material/Lock";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InboxIcon from "@mui/icons-material/Inbox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import Header from "../../../components/Header";

const SettingsShared = () => {
  const [sharedView, setSharedView] = useState(null); // 初期はnull（読み込み中）
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSharedStatus = async () => {
      try {
        const res = await fetch("/api/shared/view", {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        });
        const data = await res.json();
        setSharedView(data.sharedView);
      } catch (err) {

        setSharedView(false); // 念のため fallback
      }
    };

    fetchSharedStatus();
  }, []);

  if (sharedView === null) {
    return (
      <>
        <Header />
        <Container 
          maxWidth="md" 
          sx={{ 
            mt: 4, 
            display: 'flex', 
            justifyContent: 'center',
            // PWAボトムナビゲーション対応
            pb: { xs: 12, sm: 6 },
            minHeight: { xs: 'calc(100vh - 200px)', sm: 'auto' }
          }}
        >
          <CircularProgress color="primary" />
        </Container>
      </>
    );
  }

  return (
    <>
      <Header />
      <Container 
        maxWidth="md" 
        sx={{ 
          mt: 4, 
          // PWAボトムナビゲーション対応：安全マージンを確保
          mb: { xs: 2, sm: 6 }, 
          pb: { xs: 12, sm: 6 }, // モバイルは12（約96px）、デスクトップは6
          px: { xs: 2, sm: 3 },
          // 最小高さを確保してスクロール可能にする
          minHeight: { xs: 'calc(100vh - 200px)', sm: 'auto' }
        }}
      >
        {/* パンくずリスト */}
        <Breadcrumbs 
          separator={<NavigateNextIcon fontSize="small" />} 
          aria-label="breadcrumb"
          sx={{ mb: 3 }}
        >
          <Link
            component="button"
            underline="hover"
            color="inherit"
            sx={{ display: 'flex', alignItems: 'center' }}
            onClick={() => navigate('/dashboard')}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            ホーム
          </Link>
          <Link
            component="button"
            underline="hover"
            color="inherit"
            sx={{ display: 'flex', alignItems: 'center' }}
            onClick={() => navigate('/setting-Home')}
          >
            <SettingsIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            設定
          </Link>
          <Typography
            sx={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}
            color="text.primary"
          >
            <PeopleIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            共有設定
          </Typography>
        </Breadcrumbs>

        <Fade in={true}>
          <Box>
            {/* ヘッダーセクション */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                共有設定
              </Typography>
              <Typography color="text.secondary">
                顧客データや補充履歴の共有設定を管理します
              </Typography>
            </Box>

            <Divider sx={{ mb: 4 }} />

            {/* 共有オプションリスト */}
            <Paper 
              elevation={2} 
              sx={{ 
                borderRadius: 2,
                overflow: 'hidden',
                mb: 4
              }}
            >
              <List sx={{ p: 0 }}>
                {!sharedView && (
                  <>
                    <ListItemButton component={Link} to="/settings/shared/code" sx={{ py: 2 }}>
                      <ListItemIcon>
                        <LockIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText 
                        primary="共有コード発行・確認"
                        secondary="データを共有するための招待コードを管理します（オーナー向け）"
                      />
                      <NavigateNextIcon color="action" />
                    </ListItemButton>
                    <Divider />
                    <ListItemButton component={Link} to="/settings/shared/requests" sx={{ py: 2 }}>
                      <ListItemIcon>
                        <CheckCircleIcon color="primary" />
                      </ListItemIcon>
                      <ListItemText 
                        primary="共有・申請一覧"
                        secondary="共有申請の承認や共有ユーザーの管理を行います（オーナー向け）"
                      />
                      <NavigateNextIcon color="action" />
                    </ListItemButton>
                    <Divider />
                  </>
                )}
                <ListItemButton component={Link} to="/settings/shared/join" sx={{ py: 2 }}>
                  <ListItemIcon>
                    <InboxIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText 
                    primary="共有参加"
                    secondary="コードを使用してデータ共有に参加します（共有される側）"
                  />
                  <NavigateNextIcon color="action" />
                </ListItemButton>
              </List>
            </Paper>

            {/* 戻るボタン */}
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/setting-Home")}
                size="large"
                sx={{ minWidth: 200 }}
              >
                設定ホームに戻る
              </Button>
            </Box>
          </Box>
        </Fade>
      </Container>
    </>
  );
};

export default SettingsShared;